module.exports = __webpack_public_path__ + "static/img/index.449d55e0.png";